import { render } from "./DocAuth.vue?vue&type=template&id=3450f3e1"
import script from "./DocAuth.vue?vue&type=script&lang=js"
export * from "./DocAuth.vue?vue&type=script&lang=js"

import "./DocAuth.vue?vue&type=style&index=0&id=3450f3e1&lang=css"

import exportComponent from "/Users/victoriengarrigues/Documents/Moonarch-DEV/code/moonarch-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__